exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{height:100%!important}body{width:99%!important}a:active a:hover,a:link,a:visited{color:#000;text-decoration:none}", ""]);

// exports
